import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { LocationSelect } from 'components/Select/LocationSelect'
import { Option } from 'components/Select/Select'
import { createAnchor } from 'features/siteNetwork/siteNetworkSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { IAnchorModalProps } from 'types/siteNetwork.interface'
import { AnchorRole } from 'types/siteNetworkEnums.interface'
import { ISelectValue } from 'constants/globalTypes'
import useFocusFirstInput from 'utils/useFocusFirstInput'

const roleOptions = [
  { label: 'Primary', value: AnchorRole.Primary },
  { label: 'Tip in', value: AnchorRole.TipIn },
  { label: 'Service entry', value: AnchorRole.ServiceEntry },
  { label: 'Pickup', value: AnchorRole.Pickup },
]

export const AnchorModal = ({ closeModal, siteNodeId, nodeOptions }: IAnchorModalProps) => {
  const dispatch = useDispatch<AppDispatch>()
  const [location, setLocation] = useState<Option | null>(null)
  const [nodeId, setNodeId] = useState('')
  const [role, setRole] = useState(AnchorRole.Primary)
  useFocusFirstInput()
  useModalClose(closeModal)

  const handleSave = async () => {
    if (!location?.value || !nodeId) return
    const resp = await dispatch(
      createAnchor({
        siteNodeId,
        body: {
          locationId: Number(location.value),
          nodeId,
          role,
        },
      }),
    )
    if (resp.meta.requestStatus === 'fulfilled') {
      closeModal()
    }
  }

  return (
    <Modal black>
      <Flex column gap='1rem' width='100%'>
        <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
          <TitleText weight='bold'>Anchor location</TitleText>
          <CursorPointer onClick={closeModal}>
            <CloseIcon />
          </CursorPointer>
        </Flex>
        <BodyText grey>
          Link a registry location to a network node so routing can use locationId endpoints.
        </BodyText>
        <LocationSelect
          label='Location'
          placeholder='Select location'
          value={location}
          onChange={setLocation}
        />
        <HonestSelectInput
          nomarg
          labelText='Network node'
          options={nodeOptions}
          defaultValue={nodeId}
          onChange={(v: ISelectValue) => setNodeId(String(v.value))}
        />
        {!nodeOptions.length && (
          <Input
            nomarg
            labelText='Node id (UUID)'
            placeholder='Paste node UUID'
            value={nodeId}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNodeId(e.target.value)}
          />
        )}
        <HonestSelectInput
          nomarg
          labelText='Role'
          options={roleOptions}
          defaultValue={role}
          onChange={(v: ISelectValue) => setRole(Number(v.value))}
        />
        <Button
          mt='16'
          orange
          disabled={!location?.value || !nodeId}
          onClick={handleSave}
        >
          Create anchor
        </Button>
      </Flex>
    </Modal>
  )
}
